<template>
  <v-card elevation="4" class="dashboard-card rounded-xl pa-5 fill-height">
    <div class="dashboard-section-title mb-4">Acciones rápidas</div>
    <div class="quick-actions">
      <component
        :is="getQuickActionComponent(action)"
        v-for="action in acciones"
        :key="action.nombre"
        v-bind="getQuickActionLinkProps(action)"
        class="quick-action"
      >
        <div class="quick-icon mb-2" :style="{ backgroundColor: action.bg }">
          <v-icon :color="action.color" size="28">{{ action.icon }}</v-icon>
        </div>
        <span>{{ action.nombre }}</span>
      </component>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "QuickActionsCard",
  props: {
    acciones: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isExternalQuickAction(action) {
      const type = `${action.tipo || action.type || ""}`.toLowerCase();
      const target = action.url || action.href || action.link || action.to;

      if (["link", "url", "externo", "external"].includes(type)) return true;
      if (["ruta", "route", "interno", "internal"].includes(type)) return false;

      return typeof target === "string" && /^(https?:|mailto:|tel:)/i.test(target);
    },
    getQuickActionComponent(action) {
      return this.isExternalQuickAction(action) ? "a" : "router-link";
    },
    getQuickActionLinkProps(action) {
      if (this.isExternalQuickAction(action)) {
        return {
          href: action.url || action.href || action.link || action.to,
          target: action.target || "_blank",
          rel: "noopener noreferrer"
        };
      }

      if (action.routeName) {
        return {
          to: {
            name: action.routeName,
            params: action.params || {},
            query: action.query || {}
          }
        };
      }

      return { to: action.to || action.route || "/inicio" };
    }
  }
};
</script>

<style scoped>
.dashboard-card {
  width: 100%;
  background: #ffffff !important;
  border: 1px solid rgba(31, 45, 53, 0.08);
  box-shadow: 0 10px 28px rgba(20, 52, 57, 0.1) !important;
}

.dashboard-section-title {
  color: #20333a;
  font-size: 1.05rem;
  font-weight: 700;
}

.quick-actions {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(5, minmax(70px, 1fr));
  min-height: 104px;
  padding-top: 6px;
}

.quick-action {
  align-items: center;
  color: #20333a;
  display: flex;
  flex-direction: column;
  font-size: 0.78rem;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
}

.quick-icon {
  align-items: center;
  border-radius: 10px;
  display: flex;
  height: 54px;
  justify-content: center;
  width: 54px;
}

@media (max-width: 959px) {
  .quick-actions {
    grid-template-columns: repeat(3, minmax(80px, 1fr));
  }
}

@media (max-width: 599px) {
  .quick-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    min-height: auto;
  }

  .quick-icon {
    height: 48px;
    width: 48px;
  }
}
</style>
